// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
// import Sidebar from "../Sidebar/Sidebar";
import SearchContainer from "../SearchContainer/SearchContainer";
import "./Main.css";
class Main extends Component {
  render() {
    return (
      <div className="main">
        <div className="container main-container">
          {/* <Sidebar /> */}
          <SearchContainer />
        </div>
      </div>
    );
  }
}

export default Main;
